import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-8778e3ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col text-end sticky-top pt-5 pl-0 ml-0" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-secondary" }, "Articles", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blogTitles.length, (ix) => {
      return (_openBlock(), _createElementBlock("ul", {
        class: "list-group g-2",
        key: ix
      }, [
        _createVNode(_component_router_link, {
          class: _normalizeClass(["btn shadow-sm btn-outline-secondary m-1 link", { active : _ctx.ixIsCurrent(_ctx.blogTitles.length - ix) }]),
          to: _ctx.ixToLink(_ctx.blogTitles.length - ix)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.blogTitles[_ctx.blogTitles.length - ix]), 1)
          ]),
          _: 2
        }, 1032, ["class", "to"])
      ]))
    }), 128))
  ]))
}